module.exports = __webpack_public_path__ + "static/media/checkboxEmptyNew.090dc289.svg";